import { render } from "./PostForm.vue?vue&type=template&id=285134cf&scoped=true"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"

import "./PostForm.vue?vue&type=style&index=0&id=285134cf&scoped=true&lang=css"

import exportComponent from "E:\\backup\\Programowanie\\scheduler\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285134cf"]])

export default __exports__